import React, { useState, useContext } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { API_URL } from '../utils/runtimeConfig';
import { ErrorContext } from '../context/ErrorContext';
import "./css/Register.css"

const Register = ({ onRegisterSuccess, onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [nation, setNation] = useState(null);
  const [verificationNote, setVerificationNote] = useState('');
  const [screenshotDataUrl, setScreenshotDataUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showError } = useContext(ErrorContext);

  const handleScreenshotChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setScreenshotDataUrl('');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setScreenshotDataUrl(String(reader.result || ''));
    };
    reader.onerror = () => {
      showError('Failed to read screenshot file.');
    };
    reader.readAsDataURL(file);
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      const response = await axiosInstance.post(`${API_URL}/auth/register`, {
        username,
        password,
        nation,
        screenshotDataUrl,
        verificationNote
      });
      onRegisterSuccess(response.data);
      onClose();
    } catch (error) {
      showError(error);
      setUsername(''); 
      setPassword('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="register-form">
      <h2>Register</h2>
      <form action={`${API_URL}/auth/register`} method="POST" onSubmit={handleRegister}>
        <label>
          Username:
          <input
            type="text"
            name="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoComplete="username"
          />
        </label>
        <label>
          Password:
          <input
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
        </label>
        <label>
          Nation:
          <input
            type="text"
            name="nation"
            value={nation}
            onChange={(e) => setNation(e.target.value)}
          />
        </label>
        <label>
          Commander Profile Screenshot (optional):
          <input
            type="file"
            accept="image/*"
            onChange={handleScreenshotChange}
          />
        </label>
        {screenshotDataUrl && (
          <img className="register-screenshot-preview" src={screenshotDataUrl} alt="Verification screenshot preview" />
        )}
        <label>
          Verification Note (optional):
          <input
            type="text"
            value={verificationNote}
            onChange={(e) => setVerificationNote(e.target.value)}
            placeholder="Alliance, commander name, or context"
          />
        </label>
        <p>
          This will be the nation you receive map access to once verified.
          You can always verify later by clicking your name after login.
        </p>
        <button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Register'}</button>
      </form>
    </div>
  );
};

export default Register;
